export default __webpack_public_path__ + "static/media/fvpv-2-600.81f1e6e2.jpg";